// Content-hashed model assets (immutable cache headers set in public/_headers).
// A model swap = new file + new hash here + license audit table update in PLAN.md
// in the same commit (SKILL gate 1).

export const MODELS = {
  detector: {
    url: '/models/detector-yolov9t384.888397b9.onnx',
    /** letterboxed square input */
    inputSize: 384,
    bytes: 7771218,
    name: 'yolo-v9-t-384-license-plates-end2end (MIT, open-image-models)',
  },
  ocr: {
    url: '/models/ocr-cctxsv2-global.8031afb5.onnx',
    inputW: 128,
    inputH: 64,
    maxSlots: 10,
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_',
    padChar: '_',
    bytes: 3344292,
    name: 'cct_xs_v2_global (MIT, fast-plate-ocr)',
    regions: [
      'Albania', 'Andorra', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan',
      'Bahrain', 'Belarus', 'Belgium', 'Bosnia and Herzegovina', 'Brazil', 'Bulgaria',
      'Cambodia', 'Canada', 'Croatia', 'Cyprus', 'Czech Republic', 'Denmark', 'Estonia',
      'Finland', 'France', 'Georgia', 'Germany', 'Gibraltar', 'Greece', 'Guernsey', 'Hungary',
      'Iceland', 'Indonesia', 'Ireland', 'Israel', 'Italy', 'Latvia', 'Liechtenstein',
      'Lithuania', 'Luxembourg', 'Malaysia', 'Malta', 'Mexico', 'Moldova', 'Monaco',
      'Montenegro', 'Netherlands', 'New Zealand', 'North Macedonia', 'Norway', 'Poland',
      'Portugal', 'Qatar', 'Romania', 'San Marino', 'Serbia', 'Singapore', 'Slovakia',
      'Slovenia', 'Spain', 'Sweden', 'Switzerland', 'Thailand', 'Turkey', 'United States',
      'Ukraine', 'United Kingdom', 'Vietnam', 'Unknown',
    ],
  },
} as const;

export const TOTAL_MODEL_BYTES = MODELS.detector.bytes + MODELS.ocr.bytes;
